import { FormControl, Grid, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import RegularButton from "components/CustomButtons/Button";
import { SelectComponent } from "components/SelectMenu/SelectComponent";
import { animations } from "helpers/animations";
import { convertToMapById } from "helpers/convertToMap";
import { useForm } from "hooks/useForm";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerProducts, 
  getSchedules, 
  newCustomerService,
  selectCustomerAccount 
} from "redux/actions/customers/customersAction";
import { useHandleView } from "../useHandleView";
import { orderArrayV2 } from "helpers/orderArray";
import { CustomerCreditConditionsViewAlert } from "../creditConditions/CustomerCreditConditionsViewAlert";
import { RequestCreditConditionsViewAlert } from "../creditConditions/RequestCreditConditionsView";
import { MyAutoComplete } from "components/SelectMenu/MyAutoComplete";
import { formatNumber } from "helpers/getNumberFormats";
import { cleanNumber } from "helpers/cleanNumbers";
import { addLabelArray } from "helpers/addLabelArray";
import { ShowCreditLimit, ShowCreditSuspend } from "../accounts/DisplayAccountCredit";
import { validateObject } from "helpers/validateObject";
import { checkCreditUnlockSettings, cleanExists } from "redux/actions/creditsUnlock/creditsUnlockActions";
import moment from "moment"

function pad(n, width = 2, z = '0') {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const formatToDate = (date = new Date()) =>
  `${pad(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`


export const initialValues = {
  idAccount: "",
  paymentMethod: 'CASH',
  date: formatToDate(),
  schedule: "",
  idUnit: null,
  product: "",
  quantity: "",
  price: "",
  observations: "",
  coupon: null,
  discount: 0,
  origin: "OTHER",
  isAsap: false,
  paymentMethod: "CASH",
  paymentType: "CASH",
};

export const fieldValidations = {
  date: { required: true },
  schedule: { required: true },
  idUnit: { required: true },
  product: { required: true },
  quantity: { required: true },
  price: { required: true },
  observations: { required: false },
};

export const CustomerOrderForm = () => {
  const dispatch = useDispatch();
  const {
    schedules,
    products,
    customer,
    myCallID,
    account,
    allAccounts,
  } = useSelector(({ customersReducer }) => customersReducer);
  const { units } = useSelector(({ unitsReducer }) => unitsReducer);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { stationsList } = useSelector(({ companies }) => companies);
  const { requestCredit } = useSelector(({ creditsUnlock }) => creditsUnlock);
  const cancel = useHandleView(0);
  const limitDays =
    schedules.length > 0
      ? {
        min: schedules.length > 0 && schedules[0].value,
        max: schedules.length > 0 && schedules[schedules.length - 1].value,
      }
      : {};

  const [unitsOpt, setUnitsOpt] = useState([]);
  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    cleanForm,
    fieldErrors,
    runValidates,
    handleNumberInputOnChange
  } = useForm(initialValues, fieldValidations);

  const {
    date,
    schedule,
    product,
    quantity,
    price,
    observations,
  } = inputValues;

  const accountsMap = addLabelArray(allAccounts, "alias");
  const [dates, setDates] = useState([]);
  const creditAccount = account?.creditAccounts
  const [creditStatus, setCreditStatus] = useState(
    creditAccount?.isCreditSuspended === 1
  );
  const [requestCreditStatus, setRequestCreditStatus] = useState(requestCredit)
  const [validateType, setValidateType] = useState(false);
  const [validatedSchedules, setValidatedSchedules] = useState([]);
  const [notFunds, setNotFunds] = useState(false);
  const [isCreditNote, setIsCreditNote] = useState(false)

  const handleAccountSelect = (v) => {
    dispatch(selectCustomerAccount(v, 2));
  };

  const handleDates = ({ target }) => {
    const datesSelect = validatedSchedules.find(
      (sch) => sch.value === target.value
    );
    handleNewValues({
      ...inputValues,
      date: target.value,
    });
    setDates(datesSelect.schedules);
  };

  const handleByLts = (e) => {
    const newQuantity = cleanNumber(e.target.value);
    let fQuantity = parseFloat(newQuantity);
    let findProduct = products.find((prod) => prod.id === product);

    if (newQuantity > 0) {
      handleNewValues({
        ...inputValues,
        quantity: formatNumber(newQuantity),
        price:
          formatNumber(fQuantity *
            (findProduct?.price * findProduct?.capacity)),
      });
      handleNumberInputOnChange(e)
    } else {
      handleNewValues({
        ...inputValues,
        quantity: "",
        price: "",
      });
    }
  };
  const handleByPrice = (e) => {
    const newPrice = cleanNumber(e.target.value);
    let productInitial = products[0];
    if (newPrice > 0) {
      handleNewValues({
        ...inputValues,
        quantity: formatNumber((newPrice / productInitial.price)),
        price: formatNumber(newPrice),
      });
      handleNumberInputOnChange(e)
    } else {
      handleNewValues({
        ...inputValues,
        quantity: 0,
        price: "",
      });
    }
  };

  const handleChange = (e, value) => {
    handleNewValues({
      ...inputValues,
      idUnit: value?.id,
    });
  };

  const handleObservations = () => {
    const prdt = products.find((prod) => prod.id === product);
    const acc = accountsMap.find((acc) => acc.id === account?.id);
    handleNewValues({
      ...inputValues,
      observations: `${prdt?.type} | ${quantity} ( ${prdt?.product} ) \nTel: ${acc?.localPhone} \nReferencias:\n `,
    });
  };

  const handleSubmit = () => {
    const error = runValidates();
    if (error) return;
    const { price, ...newValues } = inputValues;
    const form = {
      ...newValues,
      idSchedule: dates.find(obj => obj.value === newValues.schedule)?.id,
      idAccount: account.id,
      callID: myCallID,
      paymentMethod: "CASH",
      paymentType: "CASH",
      details: [
        {
          id: product,
          quantity: cleanNumber(quantity),
        },
      ],
    };
    dispatch(newCustomerService(form, cancel));
    cleanForm();
    dispatch(cleanExists())
  };

  useEffect(() => {
    if (requestCredit) {
      setRequestCreditStatus(requestCredit)
    }
  }, [requestCredit])

  useEffect(() => {
    dispatch(cleanExists())
    if (validateObject(account)) {
      const findIdStation = accountsMap.find((acc) => acc.id === account?.id);
      dispatch(getSchedules(findIdStation?.idStation));
      dispatch(getCustomerProducts(account?.id, {
        stations: stationsList,
        customerIdStation: account?.idStation
      }));
      const toMap = convertToMapById(units);
      const sort = orderArrayV2(toMap, "label");
      setUnitsOpt(
        sort.filter(
          (unit) =>
            unit.idStation === findIdStation?.idStation &&
            (findIdStation?.type === "ESTACIONARIO" ? (unit.type === 'ESTACION' || unit.type === findIdStation?.type) :
              unit.type === findIdStation.type)
        )
      );
      dispatch(checkCreditUnlockSettings(account.id, findIdStation?.idStation))
    }
    //eslint-disable-next-line
  }, [account]);

  useEffect(() => {
    if (products.length > 0 && validatedSchedules.length > 0) {
      let productInitial = products[0];
      let schedulesInitial = validatedSchedules[0];
      setDates(schedulesInitial?.schedules);
      handleNewValues({
        ...inputValues,
        date: schedulesInitial?.value,
        schedule: schedulesInitial.schedules[0]?.value,
        product: productInitial?.value,
      });
      productInitial?.type === "PORTATIL"
        ? setValidateType(true)
        : setValidateType(false);
    }
    //eslint-disable-next-line
  }, [validatedSchedules, products]);

  useEffect(() => {
    setValidatedSchedules(
      (Array.isArray(schedules) ? schedules : []).map((schedule) => {
        if (schedule.value === date) {
          const currentTime = new Date().getHours();
          // Se normaliza el arreglo interno para no reventar si un schedule
          // llega sin `schedules` o en un formato distinto a arreglo.
          const innerSchedules = Array.isArray(schedule.schedules)
            ? schedule.schedules
            : [];
          const filteredSchedules = innerSchedules.filter(
            (hours) => parseInt(hours.end.slice(0, 2)) > currentTime
          );
          
          // If no schedules remain and there are schedules available, include the last one
          const newSchedules = filteredSchedules.length === 0 && innerSchedules.length > 0
            ? [innerSchedules[innerSchedules.length - 1]]
            : filteredSchedules;
            
          setDates(newSchedules);
          return {
            ...schedule,
            schedules: newSchedules,
          };
        }
        return schedule;
      })
    );
    //eslint-disabled-next-line
  }, [schedules]);

  useEffect(() => {
    const prod = products?.find((prod) => prod.id === product);
    if (prod) {
      const calculate = quantity * (prod.price * prod.capacity).toFixed(2);

      handleNewValues({
        ...inputValues,
        price: calculate,
      });
    }
    //eslint-disabled-next-line
  }, [product]);

  useEffect(() => {
    const priceFloat = cleanNumber(price);
    if (priceFloat > creditAccount?.creditAvailability && !requestCredit) {
      setNotFunds(true);
    } else {
      setNotFunds(false);
    }
  }, [quantity, account]);

  return (
    <FormControl className={animations.fadeIn}>
      <Grid container spacing={1}>
        {creditStatus && (
          <CustomerCreditConditionsViewAlert
            setCreditStatusAlert={setCreditStatus}
          />
        )}
        {requestCreditStatus && (
          <RequestCreditConditionsViewAlert
            setRequestCreditStatus={setRequestCreditStatus}
          />
        )}
        <Grid item xs={12}>
          <MyAutoComplete
            label="Cuenta *"
            options={customer?.accounts}
            action={handleAccountSelect}
            value={account}
            keySort="alias"
            size="large"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="date"
            label="Fecha de Surtido"
            type="date"
            variant="outlined"
            fullWidth
            value={date}
            defaultValue={date}
            onChange={handleDates}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: limitDays.min,
              max: limitDays.max,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectComponent
            label="Horario *"
            name="schedule"
            value={schedule}
            onChange={handleInputOnChange}
            options={dates}
            defaultValue="Selecciona un horario"
            error={fieldErrors.schedule}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectComponent
            label="Producto *"
            name="product"
            value={product}
            onChange={handleInputOnChange}
            options={products}
            defaultValue="Selecciona el producto"
            error={fieldErrors.product}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            id="unit-autocomplete"
            options={orderArrayV2(unitsOpt)}
            getOptionLabel={(unit) => unit.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Unidad"
                variant="outlined"
                error={fieldErrors.idUnit}
                helperText={fieldErrors.idUnit}
              />
            )}
            fullWidth
            onChange={(e, v) => handleChange(e, v)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Cantidad"
            name="quantity"
            // type="number"
            InputProps={{
              endAdornment: (
                <Typography style={{ marginLeft: 4 }}>
                  {products[0]?.measureUnit}
                </Typography>
              ),
              inputProps: { min: 0, right: "1" },
            }}
            value={quantity}
            onChange={handleByLts}
            variant="outlined"
            error={fieldErrors.quantity}
            helperText={fieldErrors.quantity || ""}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Importe"
            name="price"
            InputProps={{
              startAdornment: (
                <Typography tyle={{ marginLeft: 4 }}>$ </Typography>
              ),
              inputProps: { min: 0, right: "1" },
            }}
            value={price}
            onChange={handleByPrice}
            variant="outlined"
            error={fieldErrors.price}
            helperText={fieldErrors.price || ""}
            disabled={validateType}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Observaciones"
            name="observations"
            value={observations}
            onChange={handleInputOnChange}
            variant="outlined"
            multiline
            onClick={handleObservations}
          />
        </Grid>
        {notFunds && (<ShowCreditLimit />)}
        {(account?.isCreditSuspended || (creditAccount?.suspendedDate && moment(creditAccount?.suspendedDate).isSameOrBefore(moment(), 'day'))) &&  
            !requestCredit &&  (<ShowCreditSuspend date={creditAccount?.suspendedDate}/>) }
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
        >
          <RegularButton color="danger" onClick={cancel}
            disabled={isLoadingComp?.loadingCreateOrder}
          >
            Cancelar
          </RegularButton>
          <RegularButton
            color="info"
            onClick={handleSubmit}
            disabled={  isLoadingComp?.loadingCreateOrder || 
              notFunds || 
              !account ||
              (account?.isCreditSuspended || (creditAccount?.suspendedDate && moment(creditAccount?.suspendedDate).isSameOrBefore(moment(), 'day'))) &&  
              !requestCredit
            }
          >
            Crear pedido
          </RegularButton>
        </Grid>
      </Grid>
    </FormControl>
  );
};
